import React from 'react';
import { NavLink } from 'react-router-dom';
import './SideDrawer.scss';

const SideDrawer = ({ showSideDrawer, userName, isAuthenticated }) => {
  return (
    <div className={`sidebar ${!showSideDrawer ? 'sidebar--hide' : ''}`}>
      <nav className="sidebar__navigation">
        <div className="sidebar__navigation-items">
          <ul>
            <li>
              <NavLink to="/" className="sidebar__navigation-home">
                Home
              </NavLink>
            </li>
            {!isAuthenticated ? (
              <li>
                <NavLink to="/login" className="sidebar__navigation-login">
                  Login
                </NavLink>
              </li>
            ) : (
              <li>
                <NavLink
                  to={`/user/${userName}`}
                  className="sidebar__navigation-dashboard">
                  Login
                </NavLink>
              </li>
            )}
            <li>
              <NavLink to="/search" className="sidebar__navigation-search">
                Search
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default SideDrawer;
